import {Button, Form, Modal} from "react-bootstrap";
import InputField from "../../components/InputField";
import {useEffect, useMemo, useRef, useState} from "react";
import useTranslation from "../../hooks/translations";
import SelectField from "../../components/SelectField";
import {useApi} from "../../contexts/ApiProvider";
import IncomeCategoryService from "../../services/IncomeCategoryService";
import IncomeTypeService from "../../services/IncomeTypeService";

export default function IncomeCategoryModal({
                                              showModal,
                                              title,
                                              data,
                                              onModalSubmit,
                                              onModalClose
                                            }) {
  const nameField = useRef();
  const descriptionField = useRef();
  const typeField = useRef();
  const [formErrors, setFormErrors] = useState({});
  const translations = useTranslation();
  const api = useApi()
  const incomeTypeService = useMemo(() => new IncomeTypeService(api), [api]);
  const incomeCategoryService = useMemo(() => new IncomeCategoryService(api), [api]);
  const [incomeTypeOptions, setIncomeTypeOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    const getIncomeTypes = async () => {
      const response = await incomeTypeService.getAll();
      const typeOptions = response.body.map((item) => {
        return {value: item.id, name: item.name};
      })
      setIncomeTypeOptions(typeOptions);
    }
    (async () => {
      await getIncomeTypes()
      if (Object.keys(data).length > 0) {
        nameField.current.value = data.name;
        descriptionField.current.value = data.description;
        setSelectedOption(data.typeId);
      } else {
        nameField.current.focus();
      }
    })();
  }, [data]);

  // select field change event
  const handleChange = (option) => {
    setSelectedOption(option.currentTarget.value);
  };


  const handleClose = () => {
    onModalClose()
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const name = nameField.current.value;
    const description = descriptionField.current.value;
    const selectedType = parseInt(typeField.current.value);

    const errors = {};
    if (!name) {
      errors.name = translations.errorName;
    }
    if (!selectedType) {
      errors.type = translations.errorType;
    }
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    const submitData = {
      name,
      description,
      type_id: selectedType
    }

    if (data.id) {
      const response = await incomeCategoryService.put(data.id, submitData);
      if (!response.ok) {
        return
      }
    } else {
      const response = await incomeCategoryService.create(submitData);
      if (!response.ok) {
        return
      }
    }

    onModalSubmit(submitData)
  }

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title ? title : translations.incomeCategory}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit} id="incomeCategoryForm">
          <div className="mb-3">
            <div className="mb-3">
              <InputField
                name="inputName"
                label={translations.name}
                placeholder={translations.enterName}
                error={formErrors.name}
                fieldRef={nameField}
              />
            </div>
            <SelectField
              name="incomeCategoryType"
              label={translations.type}
              placeholder={translations.enterType}
              options={incomeTypeOptions}
              selectedOption={selectedOption}
              handleChange={handleChange}
              error={formErrors.type}
              fieldRef={typeField}
            />
          </div>
          <div className="mb-3">
            <InputField
              name="inputDescription"
              label={translations.description}
              placeholder={translations.enterDescription}
              error={formErrors.description}
              fieldRef={descriptionField}
              asTextarea={true}
            />
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" type="submit"
                form="incomeCategoryForm">{translations.save}</Button>
        <Button variant="secondary"
                onClick={handleClose}>{translations.close}</Button>
      </Modal.Footer>
    </Modal>
  )
}
